import { h, render } from 'preact';
import ShopTheLookModal from './shop-the-look-modal';

export default (element, data) => {
  const init = () => {
    render(<ShopTheLookModal {...data} />, element);
  };

  init();
};
